import {  Breadcrumbs, BreadcrumbsProps } from '@mui/material'
import React from 'react'

type WcBreadcrumb = BreadcrumbsProps

export const WcBreadcrumb = ({children,...props}: WcBreadcrumb) => (
    <Breadcrumbs {...props}>
      {children}
    </Breadcrumbs>
  )